<h2 mat-dialog-title>Upload Template Document</h2>
<mat-dialog-content>
  <input type="file" #fileInput hidden [accept]="supportedFileExtensions.join(',')" (change)="onFileSelected($event)" />

  <div class="upload-area" appFileDropper (fileDropped)="onFileDropped($event)">
    <mat-icon>cloud_upload</mat-icon>
    <p>Drag and drop documents here (PDF, DOCX, XLSX, TXT, etc.), or</p>
    <button mat-raised-button color="primary" (click)="fileInput.click()">Select File</button>
  </div>

  @if (file) {
    <div class="file-list-container">
      <h3>Selected File:</h3>
      <div class="file-tiles-container">
        <div class="file-tile">
          <div class="file-icon-wrapper">
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
          </div>

          <p class="file-name" [title]="file.name">{{ file.name }}</p>

          <button mat-icon-button class="remove-button" (click)="removeFile()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>

  <app-loader-button
    class="save-button"
    mat-flat-button
    [disabled]="!file"
    [loading]="isSubmitting"
    color="primary"
    (click)="onSave()"
    >Confirm</app-loader-button
  >
</mat-dialog-actions>
